/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export class MappingInfo {
        public ipAddress: string;
        public ports: string;
        public portsList: number[];
        public protocol: string;
        public weigth: number;

        constructor() {
            //
        }
    }

    export class MappingInfoRequest {
        public sourceHref: number;
        public destinyHref: number;
        public ports: string;
        public protocol: string;
        public connType: Models.NetworkInterfaceType;
        
        constructor(sourceHref: number, destinyHref: number, ports: string, protocol: string, connType: Models.NetworkInterfaceType) {
            this.sourceHref = sourceHref;
            this.destinyHref = destinyHref;
            this.ports = ports;
            this.protocol = protocol;
            this.connType = connType;
        }
    }
}